const steps = [
  {
    title: 'A semente',
    description: 'A ferramenta sempre incentivando a criar micro-comunidades a partir de si.',
    icon: (
      <svg className="w-[18px] h-[18px] text-zinc-200" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-.75-4.75a.75.75 0 0 0 1.5 0V8.66l1.95 2.1a.75.75 0 1 0 1.1-1.02l-3.25-3.5a.75.75 0 0 0-1.1 0L6.2 9.74a.75.75 0 1 0 1.1 1.02l1.95-2.1v4.59Z" clipRule="evenodd" />
      </svg>
    ),
  },
  {
    title: 'O crescimento',
    description: 'O aluno e a comunidade refletem, discutem e aprendem juntos sobre o tema proposto.',
    icon: (
      <svg className="w-[18px] h-[18px] text-zinc-200" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM6 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM1.49 15.326a.78.78 0 0 1-.358-.442 3 3 0 0 1 4.308-3.516 6.484 6.484 0 0 0-1.905 3.959c-.023.222-.014.442.025.654a4.97 4.97 0 0 1-2.07-.655ZM16.44 15.98a4.97 4.97 0 0 0 2.07-.654.78.78 0 0 0 .357-.442 3 3 0 0 0-4.308-3.517 6.484 6.484 0 0 1 1.907 3.96 2.32 2.32 0 0 1-.026.654ZM18 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM5.304 16.19a.844.844 0 0 1-.277-.71 5 5 0 0 1 9.947 0 .843.843 0 0 1-.277.71A6.975 6.975 0 0 1 9.999 17c-1.856 0-3.54-.67-4.695-1.81Z" />
      </svg>
    ),
  },
  {
    title: 'A multiplicação',
    description: 'Os membros da comunidade iniciam novas comunidades que se multiplicam.',
    icon: (
      <svg className="w-[18px] h-[18px] text-zinc-200" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM4.332 8.027a6.012 6.012 0 0 1 1.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 0 1 9 7.5V8a2 2 0 0 0 4 0 2 2 0 0 1 1.523-1.943A5.977 5.977 0 0 1 16 10c0 .34-.028.675-.083 1H15a2 2 0 0 0-2 2v2.197A5.973 5.973 0 0 1 10 16v-2a2 2 0 0 0-2-2 2 2 0 0 1-2-2 2 2 0 0 0-1.668-1.973Z" clipRule="evenodd" />
      </svg>
    ),
  },
]

export default function HowItWorks() {
  return (
    <section className="px-4 md:px-6 pb-4 md:pb-6">
      <div className="bg-zinc-900/[0.05] rounded-[32px] p-6 md:p-10 flex flex-col gap-8 md:gap-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto space-y-6">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-zinc-900 leading-tight">
            Como funciona o processo<br />de crescimento
          </h2>
          <p className="text-sm md:text-base text-zinc-900/70 leading-7">
            "Ide e fazei discípulos de todas as nações..." (Mateus 28:19). A TLC utiliza a
            tecnologia que existe para servir ao mandato de Jesus, facilitando a criação de
            micro-comunidades que se transformam e se multiplicam: Aprender e ensinar.
            Cuidar e ser cuidado.
          </p>
        </div>

        {/* Steps — single column on mobile/tablet, 3-col on desktop */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 max-w-4xl mx-auto w-full">
          {steps.map((step) => (
            <div key={step.title} className="card border border-zinc-900 shadow-sm bg-base-100">
              <div className="card-body p-6 gap-3">
                <div className="flex items-center justify-between">
                  <h3 className="font-semibold text-base text-zinc-900">{step.title}</h3>
                  <div className="w-12 h-12 rounded-full bg-zinc-900 flex items-center justify-center shrink-0">
                    {step.icon}
                  </div>
                </div>
                <p className="text-xs text-zinc-900/70 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
